import { render, staticRenderFns } from "./MuLu.vue?vue&type=template&id=7b081a03&scoped=true&"
import script from "./MuLu.vue?vue&type=script&lang=js&"
export * from "./MuLu.vue?vue&type=script&lang=js&"
import style0 from "./MuLu.vue?vue&type=style&index=0&id=7b081a03&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b081a03",
  null
  
)

export default component.exports